import { Avatar, Modal, Skeleton } from 'antd';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import PhotoGalleryModal from './PhotoGalleryModal';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { geojsonIndia } from '../../../util/methods';
import { GeoJSON, Map, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";
import "./mapStyle.css";
import "leaflet/dist/leaflet.css";
import moment from 'moment';

const markerIcon = new Icon({
    iconUrl:
        "https://cdn4.iconfinder.com/data/icons/twitter-29/512/157_Twitter_Location_Map-512.png",
    iconSize: [35, 35]
});

const AstRecord = ({ data, visible, onCancel, locations, clients, ...props }) => {
    const [images, setImages] = useState([])
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [showGallery, setShowGallery] = useState(false);
    const [latitude, setLatitude] = useState(0)
    const [longitude, setLongitude] = useState(0)
    const [astLocation, setAstLocation] = useState('');
    const [astClient, setAstClient] = useState('');

    useEffect(() => {
        if (data && data.photos) {
            setImages(data.photos);
        }

        if (data && data.latitude)
            setLatitude(data.latitude)
        if (data && data.longitude)
            setLongitude(data.longitude)
    }, [data]);

    const handlePrev = () => {
        setCurrentImageIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : 0));
    };

    const handleNext = () => {
        setCurrentImageIndex(prevIndex => (prevIndex < images.length - 1 ? prevIndex + 1 : images.length - 1));
    };

    const handleKeyDown = (event) => {
        if (visible) {
            if (event.key === 'ArrowLeft' && currentImageIndex !== 0) {
                handlePrev();
            } else if (event.key === 'ArrowRight' && currentImageIndex !== images.length - 1) {
                handleNext();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentImageIndex, visible, images]);

    useEffect(() => {
        if (data && data.location) {
            if (locations && locations.length) {
                const locIndex = locations.findIndex(loc => loc._id === data.location);
                setAstLocation(locIndex >= 0 && locations[locIndex]['name'])
            }
        }
        if (data && data.client) {
            if (clients && clients.length) {
                const clIndex = clients.findIndex(loc => loc._id === data.client);
                setAstClient(clIndex >= 0 && clients[clIndex]['name'])
            }
        }
    }, [data]);

    return (
        <div>
            <Modal visible={visible} onCancel={onCancel} footer={null} centered
                title={
                    <div style={{ height: '5vh', marginBottom: '10px' }}>
                        <span style={{ display: 'flex', flexDirection: 'column', float: 'left' }}>
                            <span><Link target={'_blank'}
                                to={`/asset-stock-taking/view/${data && data['_id']}`}>{data && data['astNo']}</Link></span>
                            {/* <span>Prepared By : {data && data.user && data.user.name}</span> */}
                        </span>

                        <span style={{
                            marginRight: '10px',
                            fontSize: '12px',
                            float: 'right',
                            display: "flex",
                            flexDirection: 'column'
                        }}>
                            <span>{data && data['time'] && new Date(data['time']).toLocaleString()}</span>
                            <span>Location: {astLocation}</span>
                            <span>Sub Location: {astClient}</span>
                        </span>
                    </div>
                }
                bodyStyle={{ padding: 0 }}
                width="70%"
            // style={{maxWidth: '800px'}}
            >
                <div style={{
                    position: 'relative',
                    // backgroundColor: 'black',
                    // display: 'flex',
                    // justifyContent: 'center',
                    // alignItems: 'center',

                    // marginTop: '10px',
                    // border: '1px dashed #000',
                    padding: '10px',
                    // borderRadius: '9px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    wordBreak: 'break-all',
                }}>
                    <div className='assets-code-section'>
                        <div className={'asset-details-location-stamp'}>
                            <div className={'asset-details-section'}>
                                <span
                                    className={'asset-details-heading'}>{data && data['assetCode']}</span>
                            </div>


                            <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>Entry Type</span>:&nbsp; {
                                    (data && data['manual']) ? 'Manual' : 'QR Code'}
                            </div>


                            {/* <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>Time</span>:&nbsp; {
                                    (data && data['time']) ? moment(data['time']).format('MM-DD-YYYY hh:mm a') : ''}
                            </div> */}

                        </div>

                        <div className={'asset-details-section-two-1'}>
                            <span
                                className={'asset-details-heading'}>Is Qr Mismatched</span>:&nbsp;
                            {(data && data['isQrMismatched']) ? <span style={{ color: 'tomato' }}>Yes</span> :
                                <span style={{ color: 'Green' }}>No</span>}
                        </div>

                        <div className={'asset-details-location-stamp'}>
                            <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>Tag Id</span>&nbsp;
                                {(data && data['link_record'])
                                    ? typeof data['link_record'] === 'string'
                                        ? data['link_record'] : data['link_record']['_id'] ? data['link_record']['code'] : data['link_record'] : data && data && data['link_record']}
                            </div>

                            <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>QR</span>:&nbsp; {
                                    (data && data['link_record'] && data['link_record']['scannerData']
                                        && data['link_record']['scannerData'].length && data['link_record']['scannerData'][0]['id'])}
                            </div>


                            <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>Tag Type</span>:&nbsp; {
                                    (data && data && data['link_record'] && data['link_record']['scannerData']
                                        && data['link_record']['scannerData'].length && data['link_record']['scannerData'][0]['tag_type']
                                        && data['link_record']['scannerData'][0]['tag_type']['name'])}
                            </div>


                            <div className={'asset-details-section'}>
                                {
                                    ((data && data['link_record'] && data['link_record']['photos']) || [])
                                        .map((p, ix) => <a style={{ display: 'block' }} key={p.url} href={`${p.url}`}
                                            target='_blank'>{`Tag Photo -${ix + 1}`}</a>)}
                            </div>

                        </div>

                        <div className={'asset-details-section-two'}>
                            <span
                                className={'asset-details-heading'}>Condition</span>:&nbsp;
                            {data ? data['condition'] && (data['condition'].name || data['condition']) : ''}
                        </div>

                        <div className={'asset-details-section-two'}>
                            <span
                                className={'asset-details-heading'}>Remark</span>:&nbsp;
                            {data ? data['remarks'] && data['remarks'] : ''}
                        </div>

                        <div className={'asset-details-location-stamp'}>
                            <div className={'asset-details-section'}>
                                <span className={'asset-details-heading'}>Entered By</span>:&nbsp;
                                {data ? ((data['user'] && data['user'] && data['user'].name) || '') : ''}
                            </div>
                            <div className={'asset-details-section'}>
                                <span
                                    className={'asset-details-heading'}>Latitude</span>:&nbsp;
                                {data ? ((data['latitude'] && data['latitude']) || (latitude) || 0).toFixed(6) : ''}
                            </div>
                            <div className={'asset-details-section'}>
                                <span
                                    className={'asset-details-heading'}>Longitude</span>:&nbsp;
                                {data && data ? ((data['longitude'] && data['longitude']) || (longitude) || 0).toFixed(6) : ''}
                            </div>
                        </div>

                    </div>
                    {
                        (data && data.photos) ? <div className='document-upload'>
                            <div className={'asset-details-heading-photo'}>Photos {data.photos.length ? `(${data.photos.length})` : ''}</div>
                            {
                                data.photos && data.photos.length ? (
                                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
                                        {data.photos.filter(p => p && p.url).map((item, index) => (
                                            <img
                                                key={item.url}
                                                src={item.url}
                                                alt={`Photo ${index + 1}`}
                                                onClick={() => setShowGallery(true)}
                                                style={{ height: 76, width: 76, objectFit: 'cover', borderRadius: 6, cursor: 'pointer', border: '1px solid #e0e0e0' }}
                                            />
                                        ))}
                                    </div>
                                ) : 'No Attachments'
                            }

                        </div> : <></>

                    }

                </div>

            </Modal>

            <PhotoGalleryModal
                visible={showGallery}
                onCancel={() => setShowGallery(false)}
                photos={data && data.photos}
                title={data && (data.assetCode || data.astNo)}
            />
        </div>
    )
}


export default AstRecord